import React, { useState, useEffect } from 'react';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { Grid, Tooltip } from "@material-ui/core";
import { FormInput } from "../../";
import { pathOr, clone } from 'ramda';
import { useSelector } from "react-redux";
import { textEllipsis } from '../../../common/utils';

///import useStyles from "./styles";
const DateSearch = ({ field, onChange, errors = {}, value = '', small = false, view = '' }) => {
	// console.log("date search:",field,value);
	//const [range, setRange] = useState(value || '=');
	const [range, setRange] = useState(value);
	let iserror = errors[field.name] ? true : false;
	let isRequired = field.required === 'true' ? '*' : '';
	let forSingleDate = ['=', 'not_equal', 'greater_than', 'less_than'];
	const [fieldsData, setFieldsData] = useState(field);
	const { userPreference, config } = useSelector((state) => state.config);

	const datef = pathOr(config.default_date_format, ['attributes', 'global', 'datef'], userPreference);
	const date_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_format'], userPreference);
	const time_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'time_reg_format'], userPreference);
	const date_reg_positions = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_positions'], userPreference);

	let newDatef = datef.replace("Y", "yyyy");
	newDatef = newDatef.replace("m", "MM");
	newDatef = newDatef.replace("d", "dd");


	const handleChange = (name, value, type = '', newDatef) => {
		//console.log("DateSearch field",field);
		//console.log("DateSearch value",name);
		//console.log("DateSearch value1",value);
		let initialValues = [];
		let initialValuesClone = clone(fieldsData);

		if (type === 'range') {
			setRange(value);
			initialValues[field.field_key] = value;
			initialValues['value'] = value;
			let dateSingleValue = ['next_7_days', 'last_7_days', 'last_month', 'this_month', 'next_month', 'last_30_days', 'next_30_days', 'this_year', 'last_year', 'next_year'];
			let dateDoubleValue = ['=', "not_equal", 'less_than', 'greater_than', 'less_than_equals', 'greater_than_equals'];
			let dateTripalValue = ['between'];

			if (dateSingleValue.some(item => value === item)) {
				initialValues[`${field.field_key}_range_choice`] = '';

			} else if (dateDoubleValue.some(item => value === item)) {
				initialValues[`range_${field.field_key}`] = '';

			} else if (dateTripalValue.some(item => value === item)) {
				initialValues[`${field.field_key}_range_choice`] = '';
				initialValues[`range_${field.field_key}`] = '';
			}
			else {
				initialValues[`${field.field_key}_range_choice`] = '';
				initialValues[`range_${field.field_key}`] = '';
			}
		}
		else {
			if (value && value != 'Invalid Date') {
				value = newDatef;
				// if(type=='start_range')
				// setStartRangeDateEntered(newDatef);
				// else if(type=='end_range')
				// setEndRangeDateEntered(newDatef);
				delete errors[type + '_' + field.name];
			} else {
				value = "";
				errors[type + '_' + field.name] = "Invalid Date";
			}
			// let current_datetime = new Date(value);
			// value = current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + current_datetime.getDate()).slice(-2);
		}
		initialValues[name] = value;
		setFieldsData({ ...fieldsData, ...initialValues });
		onChange(fieldsData);


		//onChange(fieldsData);
	}
	useEffect(() => onChange(clone(fieldsData)), [fieldsData]);


	const isTime = (timeStr) => {
		var timeRegex = time_reg_format;
		timeRegex = timeRegex.replace(/[ ]*\([^)]*m\)/i, '');
		if (timeStr.length == 0) {
			return true;
		}
		let myregexp = new RegExp(timeRegex);
		if (!myregexp.test(timeStr)) {
			return false;
		}
		return true;
	}

	const getDateObject = (dtStr) => {
		if (dtStr.length === 0) {
			return true;
		}
		let myregexp = new RegExp(date_reg_format);
		if (myregexp.exec(dtStr)) {
			var dt = myregexp.exec(dtStr);
		}
		else {
			return false;
		}
		var yr = dt[date_reg_positions['Y']];
		var mh = dt[date_reg_positions['m']];
		var dy = dt[date_reg_positions['d']];
		var dtar = dtStr.split(' ');
		var date1 = '';
		if (typeof (dtar[1]) != 'undefined' && isTime(dtar[1], time_reg_format)) {
			var t1 = dtar[1].replace(/am/i, ' AM');
			t1 = t1.replace(/pm/i, ' PM');
			t1 = t1.replace(/\./, ':');
			date1 = new Date(mh + '/' + dy + '/' + yr + ' ' + t1);
		} else {
			date1 = new Date(mh + '/' + dy + '/' + yr);
		}
		if (isNaN(date1.valueOf())) {
			return null;
		}
		return date1;
	}
	// console.log("fieldsData",fieldsData);
	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={forSingleDate.includes(range) ? 6 : 12} md={forSingleDate.includes(range) ? 6 : 12} key={field.field_key}>
					<Tooltip
						title={field.comment || ''}
						disableHoverListener={field.comment ? false : true}
						placement="top-start"
						disableFocusListener={field.comment ? false : true}
						disableTouchListener={field.comment ? false : true}
					>
						<FormInput
							field={{ ...field, field_key: `${field.name}_range_choice`, name: `${field.name}_range_choice`, type: 'enum' }}
							onChange={(value) => handleChange(field.name, value, 'range')}
							small={true}
							// value={fieldsData[`${field.name}_range_choice`]?fieldsData[`${field.name}_range_choice`]:"="}
							value={range}
						/>
					</Tooltip>
				</Grid>
				{
					(range != 'between' && forSingleDate.includes(range)) ?
						<Grid item xs={field.type === "currency" ? 12 : 6} md={field.type === "currency" ? 8 : 6} key={`range_${field.name}`}>
							<Tooltip
								title={field.label + " " + isRequired || ''}
								disableHoverListener={field.label + " " + isRequired ? false : true}
								placement="top-start"
								disableFocusListener={field.label + " " + isRequired ? false : true}
								disableTouchListener={field.label + " " + isRequired ? false : true}
							>
								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<KeyboardDatePicker
										autoOk
										error={iserror}
										variant="inline"
										inputVariant="outlined"
										label={textEllipsis(field.label + " " + isRequired, 22)}
										id={`range_${field.name}`}
										name={`range_${field.name}`}
										format={newDatef}
										value={fieldsData[`range_${field.name}`] ? getDateObject(fieldsData[`range_${field.name}`]) : null}
										size={small ? 'small' : 'medium'}
										fullWidth
										InputAdornmentProps={{ position: 'start' }}
										onChange={(value, newDatef) => handleChange(`range_${field.name}`, value, 'date', newDatef)}
										helperText={errors[`range_${field.name}`] ? errors[`range_${field.name}`] : null}
									// InputProps={{ readOnly: true }}
									/>
								</MuiPickersUtilsProvider>
							</Tooltip>
						</Grid>
						: ''
				}
				{
					range === 'between' ?
						<>
							<Grid item xs={6} md={6} key={`start_range_${field.name}`}>
								<Tooltip
									title={field.label + " " + isRequired || ''}
									disableHoverListener={field.label + " " + isRequired ? false : true}
									placement="top-start"
									disableFocusListener={field.label + " " + isRequired ? false : true}
									disableTouchListener={field.label + " " + isRequired ? false : true}
								>
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
										<KeyboardDatePicker
											autoOk
											error={iserror}
											variant="inline"
											inputVariant="outlined"
											label={textEllipsis(field.label + " " + isRequired, 22)}
											id={`start_range_${field.name}`}
											name={`start_range_${field.name}`}
											format={newDatef}
											value={fieldsData[`start_range_${field.name}`] ? getDateObject(fieldsData[`start_range_${field.name}`]) : null}
											size={small ? 'small' : 'medium'}
											fullWidth
											InputAdornmentProps={{ position: 'start' }}
											onChange={(value, newDatef) => handleChange(`start_range_${field.name}`, value, 'start_range', newDatef)}
											helperText={errors[`start_range_${field.name}`] ? errors[`start_range_${field.name}`] : null}
										// InputProps={{ readOnly: true }}
										/>
									</MuiPickersUtilsProvider>
								</Tooltip>
							</Grid>
							<Grid item xs={6} md={6} key={`end_range_${field.name}`}>
								<Tooltip
									title={field.label + " " + isRequired || ''}
									disableHoverListener={field.label + " " + isRequired ? false : true}
									placement="top-start"
									disableFocusListener={field.label + " " + isRequired ? false : true}
									disableTouchListener={field.label + " " + isRequired ? false : true}
								>
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
										<KeyboardDatePicker
											autoOk
											error={iserror}
											variant="inline"
											inputVariant="outlined"
											label={textEllipsis(field.label + " " + isRequired, 22)}
											id={`end_range_${field.name}`}
											name={`end_range_${field.name}`}
											format={newDatef}
											value={fieldsData[`end_range_${field.name}`] ? getDateObject(fieldsData[`end_range_${field.name}`]) : null}
											size={small ? 'small' : 'medium'}
											fullWidth
											InputAdornmentProps={{ position: 'start' }}
											onChange={(value, newDatef) => handleChange(`end_range_${field.name}`, value, 'end_rang', newDatef)}
											helperText={errors[`end_range_${field.name}`] ? errors[`end_range_${field.name}`] : null}
										// InputProps={{ readOnly: true }}
										/>
									</MuiPickersUtilsProvider>
								</Tooltip>
							</Grid>
						</>
						: ''
				}
			</Grid>
		</>
	);
};

export default DateSearch;
